export const layoutLocators = {
  draggable: 'Layout-Draggable',
};
